<template>
  <div id="guest" class="page">
    <div id="foto_container">
      <div id="foto">
        <img src="../assets/img/ben-2018.jpeg">
      </div>
      <div id="kidsname">
          <p>Einladen</p>
      </div>
    </div>
    <div id="wishinfo">
      <div class="columns">
        <div class="column">
         <p><input placeholder="Vorname" name="surname" v-model="guest.surname"></p>
          <p><input placeholder="Nachname" name="familyname" v-model="guest.familyname"></p>
          <p><input placeholder="aus (Stadt)" name="city" v-model="guest.city"></p>
          <p><input placeholder="Bild" name="image" v-model="guest.image"></p>
          
          <div class="actions">
            <p><a @click.prevent="postGuest" class="button">
            auf die Gästeliste setzen
            </a></p>
          </div>          
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {db} from '../service/firebase';  
export default {
  name: 'Guest',
  components: {
    
  },
  data () {
      return {
        guest : {
        'familyname':null,
        'surname':null,
        'city':null,
        'image':null
        }
      }
  },
  methods: {
    postGuest () {
       var ref =  db.ref('/parties/' + this.$store.state.currentParty + '/guests' ).push( this.guest )

/*
        var updates = {};
        updates['/parties/' + this.$store.state.currentParty + '/wishes'] = this.user.id;
        var ref =  db.ref().update(updates)

      
      this.$root.$firebaseRefs.wishes.push(
          {
          'url': this.url,
          'name': this.name,
          'price': this.price,
          'info': 'Posted by Matt',
          'created_at': -1 * new Date().getTime()
        })
        .then(this.$router.push('/wishlist'))
*/
    }  
  }
}

</script>
<style>
</style>
